import { render, staticRenderFns } from "./BaseAndTargetYearSelector.vue?vue&type=template&id=0cddddf4&scoped=true&"
import script from "./BaseAndTargetYearSelector.vue?vue&type=script&lang=ts&"
export * from "./BaseAndTargetYearSelector.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAndTargetYearSelector.vue?vue&type=style&index=0&id=0cddddf4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddddf4",
  null
  
)

export default component.exports